import React, { useCallback, useState } from "react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { allReleveList, deletereleve } from "../../Redux/releveNonReduce";
import jwt_decode from "jwt-decode";
import NotificationAlert from "react-notification-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { fetchGrossiste } from "../../Redux/grossisteReduce";
import MaterialReactTable from "material-react-table";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function ListeReleveInserer({ obj,client }) {
  const dispatch = useDispatch();
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const navigate = useHistory();
  var token = localStorage.getItem("x-access-token");
  var year = localStorage.getItem("annee");
  localStorage.removeItem("bonification");
  var decoded = jwt_decode(token);
  const id = decoded.id;
  const idRole = obj.user.id_role;

  const [data, setData] = React.useState([]);
  const [loader, setLoader] = React.useState(true);

  const [options, setOptions] = React.useState([
    {
      value: "",
      label: "Commercial",
      isDisabled: true,
    },
  ]);
  const [delegueSelect, setDelegueSelect] = React.useState({
    value: 0,
    label: "Tous",
  });

  const [grossisteSelect, setGrossisteSelect] = React.useState({
    value: 0,
    label: "Tous",
  });

  const notificationAlertRef = React.useRef(null);
  const [alert, setAlert] = React.useState(null);
  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{msg}</div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const confirmMessage = (bl, idRow) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={"Étes Vous sûr de supprimer ce Relevé?"}
        onConfirm={() => {
          deleteReleve(bl.id, idRow);
        }}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      ></SweetAlert>
    );
  };
  
  async function deleteReleve(id, idRow) {
    try {
      const result = await dispatch(deletereleve({ id }));

      // Vérifie si la suppression a réussi
      console.log(result.payload)
      if (result?.payload) {
        listeReleve(0, id);
        notify("tr", "Supprimé avec succès", "success");
      } else {
        notify("tr", "Erreur lors de la suppression", "danger");
      }
    } catch (error) {
      console.log(error)
      console.error("Erreur suppression relevé:", error);
      notify("tr", "Erreur inattendue", "danger");
    } finally {
      hideAlert();
    }
  }

  const hideAlert = () => {
    setAlert(null);
  };
  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}
        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

      />
    );
  }
  const [columns] = useState([
    {
      header: "Grossiste",
      accessorKey: "grossiste",
    },
    {
      header: "nom fichier",
      accessorKey: "namefile",
    },
    {
      header: "Mois",
      accessorKey: "mois",
    },
    {
      header: "visualization",
      accessorKey: "file",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.id}
          onClick={(e) => {
            paymentBl(cell.row.original.id);
            localStorage.setItem(
              "file",
              cell.row.original.file
            );
            localStorage.setItem(
              "returnList",
              "listereleveinserer"
            );
          }}
          className="btn btn-info ml-1 "
        >
          <i
            className="fa fa-eye"
            id={"idLigne_" + cell.row.original.id}
          />
          
        </Button>
      ),
    },
    {
      header: "actions",
      accessorKey: "id",
      Cell: ({ cell }) =>
        idRole === 6 ? (
          <div>
            <Button
              id={"idLigne_" + cell.row.original.id}
              onClick={(e) => {
                confirmMessage(cell.row.original, cell.row.id);
              }}
              className="delete btn btn-danger ml-1 float-right"
            >
              <i
                className="fa fa-trash"
                id={"idLigne_" + cell.row.original.id}
              />
            </Button>
          </div>
        ) : (
          ""
        ),
    },
  ])




  const listeReleve = useCallback(
    async (idGrossiste, idDelegue, client) => {
      var idUser = 0
      var list = await dispatch(
        allReleveList({
          idDelegue: idUser,
          idRole: idRole,
          annee: year,
          grossiste: idGrossiste,
          client: client,
        })
      );
      var res = list.payload;
      var array = [];
      res.forEach((element) => {
        var e = {
          id: element.id,
          grossiste: element.grossistes.Raison_sociale,
          code: element.grossistes.Code_client,
          mois: element.mois,
          file: element.file,
          namefile: element.namefile,
          createdAt: element.createdAt
        };
        array.push(e);
      });
      setLoader(false);
      setData(array);
    },
    [dispatch, id, idRole, year]
  );
  React.useEffect(() => {
    if (idRole === 2) {
      listeReleve(0, id, client);
    } else {
      listeReleve(0, 0, client);
    }
   

  }, [listeReleve, id, idRole]);

  function paymentBl(idBl) {
    navigate.push(client + "/telechargerFichierReleveInserer/" + idBl);
  }



  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("listeRelevé");

    // Définir les colonnes
    worksheet.columns = [
      { header: "Nom Commercial", key: "delegue", width: 20 },
      { header: "Grossiste", key: "grossiste", width: 20 },
      { header: "Mois", key: "mois", width: 10 },
      { header: "Date insertion", key: "createdAt", width: 20 },
    ];

    // Ajouter les lignes de données
    data.forEach((row) => {
      worksheet.addRow({
        delegue: row.delegue,
        grossiste: row.grossiste,
        mois: row.mois,
        createdAt: row.createdAt,
      });
    });

    // Générer le fichier Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "listeRelevé.xlsx");
  };

  return (
    <>
      {alert}
      <Container fluid>
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        {
          idRole == 6 && (<Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={() => {
                  navigate.push(client + "/releveinserer");
                }}
              >
                <span className="btn-label">
                  <i className="fas fa-plus"></i>
                </span>
                Ajouter relevé
              </Button>
            </Col>
          </Row>


          )
        }

        <br></br>

        <Row>
          <Col md="12">

            <Card>

              <Card.Header>
                <Card.Title as="h4">Liste des relevés grossistes <Button id="export" className="btn-export btn" onClick={exportToExcel}>
                  Export Liste
                </Button></Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={data} loader={loader} ></ListTable>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default ListeReleveInserer;
